// extracted by mini-css-extract-plugin
export var blocks = "styles-module--blocks--0KZ2g";
export var block = "styles-module--block--l1Fr7";
export var blockWrapper = "styles-module--blockWrapper--I0jSA";
export var icon = "styles-module--icon--l-HQN";
export var blockTitle = "styles-module--blockTitle--GPkbo";
export var blockContent = "styles-module--blockContent--7mJIV";
export var link = "styles-module--link--XsSFf";
export var container = "styles-module--container--ZJGoP";
export var title = "styles-module--title--TF7+8";